import { z } from "zod";

import { JobChangeIntervalUnit } from "@/enum/list.enum";

// Signal Interval Mode enum for TRACKER lists
export enum SignalIntervalMode {
	ROLLING = "ROLLING",
	FIXED = "FIXED",
}

/**
 * The job-change and signal-scoring interval fields a list carries, shared by the list response,
 * the settings form schemas and the update request. They were spelled out four times in
 * `list.ts`; extracted (PREC-4261) so that file can take the email-deliverability overrides
 * without growing past its file-length ratchet. Spread with `...ListIntervalSettingsSchema.shape`.
 */
export const ListIntervalSettingsSchema = z.object({
	// Job Change tracking fields
	jobChangeIntervalPrio1: z.number().nullable().optional(),
	jobChangeIntervalPrio1Unit: z.nativeEnum(JobChangeIntervalUnit).nullable().optional(),
	jobChangeIntervalPrio2: z.number().nullable().optional(),
	jobChangeIntervalPrio2Unit: z.nativeEnum(JobChangeIntervalUnit).nullable().optional(),
	jobChangeIntervalPrio3: z.number().nullable().optional(),
	jobChangeIntervalPrio3Unit: z.nativeEnum(JobChangeIntervalUnit).nullable().optional(),
	// Job Change deactivation settings
	jobChangeDeactivateOnChangedEmployer: z.boolean().nullable().optional(),
	jobChangeDeactivateOnChangedRole: z.boolean().nullable().optional(),
	jobChangeDeactivateOnAddedEmployer: z.boolean().nullable().optional(),
	jobChangeDeactivateOnAddedRole: z.boolean().nullable().optional(),
	// Signal interval fields (for TRACKER lists)
	signalIntervalPrio1: z.number().nullable().optional(),
	signalIntervalPrio1Unit: z.nativeEnum(JobChangeIntervalUnit).nullable().optional(),
	signalIntervalPrio2: z.number().nullable().optional(),
	signalIntervalPrio2Unit: z.nativeEnum(JobChangeIntervalUnit).nullable().optional(),
	signalIntervalPrio3: z.number().nullable().optional(),
	signalIntervalPrio3Unit: z.nativeEnum(JobChangeIntervalUnit).nullable().optional(),
	// Signal interval mode configuration (for TRACKER lists)
	signalIntervalMode: z.nativeEnum(SignalIntervalMode).nullable().optional(),
	signalScheduleStartDate: z.string().nullable().optional(),
});
